import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { UserGroupIcon, AcademicCapIcon } from '@heroicons/react/24/outline';

const Sidebar = () => {
    const location = useLocation();

    return (
        <div className="w-64 bg-white border-r border-gray-200 min-h-full">
            <div className="p-6">
                <div className="mb-8">
                    <h2 className="text-xl font-bold text-gray-800">
                        Admin Portal
                    </h2>
                    <p className="text-sm text-gray-500 mt-1">
                        Manage your organization
                    </p>
                </div>

                <nav className="space-y-1">
                    <Link
                        to="/admin"
                        className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-150 ${
                            location.pathname === '/admin'
                                ? 'bg-purple-50 text-purple-700'
                                : 'text-gray-600 hover:bg-gray-50'
                        }`}
                    >
                        <span className="mr-3">📊</span>
                        <span>Dashboard</span>
                    </Link>

                    {/* Jobs Management Section */}
                    <div className="pt-4">
                        <p className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Jobs Management
                        </p>
                        <div className="mt-2 space-y-1">
                            <Link
                                to="/admin/jobs"
                                className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-150 ${
                                    location.pathname.includes('/admin/jobs')
                                        ? 'bg-purple-50 text-purple-700'
                                        : 'text-gray-600 hover:bg-gray-50'
                                }`}
                            >
                                <span className="mr-3">💼</span>
                                <span>Jobs</span>
                            </Link>
                            <Link
                                to="/admin/companies"
                                className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-150 ${
                                    location.pathname.includes('/admin/companies')
                                        ? 'bg-purple-50 text-purple-700'
                                        : 'text-gray-600 hover:bg-gray-50'
                                }`}
                            >
                                <span className="mr-3">🏢</span>
                                <span>Companies</span>
                            </Link>
                            <Link
                                to="/admin/job-seekers"
                                className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-150 ${
                                    location.pathname.includes('/admin/job-seekers')
                                        ? 'bg-purple-50 text-purple-700'
                                        : 'text-gray-600 hover:bg-gray-50'
                                }`}
                            >
                                <span className="mr-3">👥</span>
                                <span>Job Seekers</span>
                            </Link>
                        </div>
                    </div>

                    {/* Skills Management Section */}
                    <div className="pt-4">
                        <p className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Skills Management
                        </p>
                        <div className="mt-2 space-y-1">
                            <Link
                                to="/admin/skills"
                                className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-150 ${
                                    location.pathname.includes('/admin/skills')
                                        ? 'bg-purple-50 text-purple-700'
                                        : 'text-gray-600 hover:bg-gray-50'
                                }`}
                            >
                                <span className="mr-3">🔍</span>
                                <span>Skills</span>
                            </Link>
                        </div>
                    </div>

                    {/* Settings Section */}
                    <div className="pt-4">
                        <p className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                            Settings
                        </p>
                        <div className="mt-2 space-y-1">
                            <Link
                                to="/admin/todo-lists"
                                className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-150 ${
                                    location.pathname.includes('/admin/todo-lists')
                                        ? 'bg-purple-50 text-purple-700'
                                        : 'text-gray-600 hover:bg-gray-50'
                                }`}
                            >
                                <span className="mr-3">⚙️</span>
                                <span>ToDo Lists</span>
                            </Link>
                        </div>
                    </div>
                </nav>
            </div>

            <div className="absolute bottom-0 w-64 p-6 border-t border-gray-200">
                <div className="flex items-center">
                    <div className="flex-shrink-0">
                        <img
                            className="h-8 w-8 rounded-full"
                            src="https://ui-avatars.com/api/?name=Admin&background=random"
                            alt=""
                        />
                    </div>
                    <div className="ml-3">
                        <p className="text-sm font-medium text-gray-700">Admin User</p>
                        <p className="text-xs text-gray-500">View Profile</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar; 